import { useTranslation } from 'react-i18next'

import { SortDebugValue } from '@wwt/core/admin'
import { getValidGroupName } from '@wwt/shared/utils'
import { GroupAllFeaturesResultElement } from '@wwt/shared/utils/extractFeatures/groupFeatures/groupAllFeaturesTypes.ts'
import { GroupTitle } from '@wwt/ui/components/Offer/ui/GroupTitle.tsx'

import { FeatureListWithOfferConfiguration } from '@/entities/feature'
import { cn } from '@/shared/lib/cn'

interface GroupWithFeaturesProps {
	groupsWithFeatures: GroupAllFeaturesResultElement[]
	defaultGroupName: string
	i18nGroupKey?: 'groups.hotelGroup' | 'groups.roomGroup'
	className?: string
	featureListClassName?: string
	isDisabledOfferConfiguration?: boolean

	/**
	 * Callback which will be called when need open offer configuration
	 */
	onShowOfferConfiguration: (selectedFeature?: string) => void
}

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const GroupWithFeatures = ({
	groupsWithFeatures,
	defaultGroupName,
	i18nGroupKey,
	className,
	featureListClassName,
	isDisabledOfferConfiguration,
	onShowOfferConfiguration
}: GroupWithFeaturesProps) => {
	const { t } = useTranslation('room-page')

	return (
		<>
			{groupsWithFeatures.map(({ group, features }) => {
				if (features.length === 0) return null

				const validGroupName = getValidGroupName(group.name, defaultGroupName)

				const groupNameForShow = i18nGroupKey
					? t(i18nGroupKey, {
							groupName: validGroupName
						})
					: validGroupName

				return (
					<div
						className={className}
						key={`${group.name}-${features
							?.map(feature => feature.name)
							.join(',')}`}
					>
						<GroupTitle
							name={groupNameForShow}
							iconName={group.iconName}
						>
							<SortDebugValue wwtPriority={group.priority} />
						</GroupTitle>

						<FeatureListWithOfferConfiguration
							classNames={{ base: cn('mt-4', featureListClassName) }}
							onShowOfferConfiguration={onShowOfferConfiguration}
							features={features}
							isDisabledOfferConfiguration={isDisabledOfferConfiguration}
						/>
					</div>
				)
			})}
		</>
	)
}
